import type { FileUIPart, UIMessage } from "ai";

import type { AgentChatMessage } from "@fitness-app/data-models";

import { emptyChatMessageParts } from "./constants";

export const getMessageText = (message: UIMessage): string =>
  (message.parts ?? [])
    .map((part) => {
      if (part.type === "text") return part.text;
      if (part.type === "reasoning") return part.text;
      return "";
    })
    .filter(Boolean)
    .join("\n\n");

export const getMessageFiles = (message: UIMessage): (FileUIPart & { id: string })[] =>
  (message.parts ?? [])
    .map((part, index) => (part.type === "file" ? { ...part, id: `${message.id}-${index}` } : null))
    .filter((part): part is FileUIPart & { id: string } => Boolean(part));

export const mapStoredMessage = (row: AgentChatMessage): UIMessage => ({
  id: row.id,
  role: row.role as UIMessage["role"],
  parts: Array.isArray(row.parts) ? (row.parts as UIMessage["parts"]) : emptyChatMessageParts,
});
